module.exports = __webpack_public_path__ + "img/icon-tablet-green-success.1718976e.svg";